/**
 * Reviews JudgeMe Manager - Moon Moon Agency
 * Fetches rating from JudgeMe API and moves the native write-review button to the right column.
 */

const ReviewsJudgemeManager = {
	config: {
		selectors: {
			section: '.mm-reviews-judgeme',
			scoreValue: '.mm-reviews-judgeme__score-value',
			scoreBlock: '.mm-reviews-judgeme__score',
			rightColumn: '.mm-reviews-judgeme__right',
			nativeButton: '.mm-reviews-judgeme__widget .jm-action-buttons',
		},
	},

	init() {
		const section = window.getElement(this.config.selectors.section);
		if (!section) return;

		const shopDomain = section.dataset.shopDomain;
		if (!shopDomain) return;

		this._fetchRating(shopDomain, section);
		this._moveNativeButton(section);
	},

	_fetchRating(shopDomain, section) {
		const scoreEl = section.querySelector(this.config.selectors.scoreValue);
		if (!scoreEl) return;

		fetch(`https://judge.me/api/v1/reviews?shop_domain=${encodeURIComponent(shopDomain)}&per_page=1`)
			.then(r => r.ok ? r.json() : Promise.reject(r.status))
			.then(data => {
				const rating = data?.rating ?? data?.average_rating ?? data?.reviews?.[0]?.rating;
				if (typeof rating === 'number') {
					scoreEl.textContent = rating.toFixed(2);
				}
				window.log('info', '⭐ [REVIEWS_JUDGEME]', 'Rating fetched', { rating });
			})
			.catch(err => {
				window.log('warn', '⭐ [REVIEWS_JUDGEME]', 'Rating fetch failed', { err });
				scoreEl.textContent = '';
			});
	},

	_moveNativeButton(section) {
		/* JudgeMe renders .jm-action-buttons asynchronously — observe until it appears,
		   then move it into the score block in the right column. */
		const rightColumn = section.querySelector(this.config.selectors.rightColumn);
		if (!rightColumn) return;

		const observer = new MutationObserver(() => {
			const actionButtons = section.querySelector(this.config.selectors.nativeButton);
			if (!actionButtons) return;

			observer.disconnect();
			rightColumn.appendChild(actionButtons);
			window.log('info', '⭐ [REVIEWS_JUDGEME]', 'Native button moved to right column');
		});

		observer.observe(section, { childList: true, subtree: true });

		/* Safety timeout — stop observing after 10s if JudgeMe never renders */
		setTimeout(() => observer.disconnect(), 10000);
	},
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => ReviewsJudgemeManager.init());
} else {
	ReviewsJudgemeManager.init();
}
